export const generatedBetaClosureStatus = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-beta-closure-status",
  "operatingRule": "This receipt is the single fail-closed beta closure view. It summarizes what the platform may be used for now, which proof gates remain blocked, and which evidence hashes must change before public/customer/commercial readiness can be claimed.",
  "currentUseState": {
    "internalResearchAllowed": true,
    "gatedReviewerAccessAllowed": true,
    "publicBetaAllowed": false,
    "customerDeliveryAllowed": false,
    "customerDecisionUseAllowed": false,
    "commercialUseAllowed": false,
    "operationalMissionUseAllowed": false,
    "reason": "The platform is a gated internal/reviewer beta until alert recovery, owner approval, UI approval, source-use review, and runtime science validation gates close."
  },
  "readinessSummary": {
    "targetScore": 98,
    "lowestCurrentScore": 90,
    "highestCurrentScore": 98,
    "blockingCategoryCount": 4,
    "categoryScores": [
      {
        "id": "local-functional-beta",
        "label": "Local functional beta",
        "currentScore": 98,
        "targetScore": 98,
        "gap": 0
      },
      {
        "id": "science-math-credibility",
        "label": "Science/math credibility for beta",
        "currentScore": 96,
        "targetScore": 98,
        "gap": 2
      },
      {
        "id": "ui-review-readiness",
        "label": "UI review readiness",
        "currentScore": 90,
        "targetScore": 98,
        "gap": 8
      },
      {
        "id": "deployment-readiness",
        "label": "Deployment readiness",
        "currentScore": 96,
        "targetScore": 98,
        "gap": 2
      },
      {
        "id": "public-gated-live",
        "label": "Public/gated website live status",
        "currentScore": 96,
        "targetScore": 98,
        "gap": 2
      }
    ]
  },
  "releaseSummary": {
    "releaseAllowed": false,
    "gateCount": 41,
    "blockedGateCount": 12,
    "statusCounts": {
      "pass": 29,
      "blocked": 6,
      "partial": 2,
      "human-review-pending": 2,
      "external-proof-pending": 2
    }
  },
  "reviewSummary": {
    "approvalSlotCount": 7,
    "approvedSlotCount": 0,
    "blockedSlotCount": 7,
    "releaseApprovalAllowed": false
  },
  "customerSummary": {
    "packageCount": 3,
    "blockedPackageCount": 3,
    "customerReportPacketCount": 3,
    "blockedReportPacketCount": 3,
    "workspaceCount": 3,
    "blockedWorkspaceCount": 3
  },
  "scienceSummary": {
    "runtimeContractCount": 5,
    "promotedRuntimeContractCount": 2,
    "blockedRuntimeContractCount": 3,
    "trajectoryRows": 4,
    "trajectoryBlockedRows": 4,
    "trajectoryCrossToolState": "blocked-until-orekit-gmat-tudat-runtime-artifacts-promote"
  },
  "sourceUseSummary": {
    "sourceCount": 33,
    "blockedSourceCount": 33,
    "classCount": 5,
    "customerUseAllowed": false,
    "commercialUseAllowed": false
  },
  "monitorProofContract": {
    "requiredCommand": "npm run live:gate",
    "requiredChecks": [
      "anonymous Cloudflare Access challenge",
      "monitor status endpoint token protection",
      "monitor service-token app reachability",
      "artifact-source-use-clearance-dossier",
      "artifact-trajectory-validation-matrix",
      "artifact-beta-closure-status",
      "artifact-live-small-body-review-queue",
      "artifact-candidate-sbdb-refresh-manifest",
      "artifact-business-platform-roadmap",
      "artifact-release-evidence-ledger",
      "artifact-ui-fidelity-ledger",
      "security headers"
    ],
    "currentKnownBlocker": "Alert webhook/recovery path still requires a real webhook or email relay verification."
  },
  "blockerCount": 27,
  "blockerLaneCounts": {
    "readiness": 5,
    "release-gate": 12,
    "human-approval": 7,
    "runtime-science": 3
  },
  "blockerOwnerCounts": {
    "Release engineering": 4,
    "Cloudflare/DNS": 2,
    "Science kernel": 1,
    "Product design": 1,
    "Business modeling": 1,
    "Manufacturing science": 1,
    "Product/review": 1,
    "Resource ledger": 1,
    "Source/legal review": 1,
    "Research operations": 2,
    "Product design / owner": 1,
    "Science/product governance": 1,
    "Science compute": 4,
    "Research product lead": 1,
    "Product owner": 1,
    "Release manager": 1,
    "Science compute lead": 1,
    "Legal/source review": 1,
    "Product engineering": 1
  },
  "blockerIds": [
    "readiness-deployment-readiness",
    "readiness-public-gated-live",
    "readiness-science-math-credibility",
    "readiness-ui-review-readiness",
    "release-economics-promotion",
    "release-materials-process-promotion",
    "release-research-package-approval",
    "release-resource-candidate-promotion",
    "release-source-use-rights-review",
    "release-workspace-review-gates",
    "release-alert-webhook-recovery-proof",
    "release-ci-secrets-deploy-proof",
    "release-cloudflare-access-owner-approval",
    "release-ui-fidelity-owner-approval",
    "release-model-validation-protocols",
    "release-runtime-sidecar-promotion",
    "approval-customer-report-delivery-approval",
    "approval-monitor-alert-recovery-proof",
    "approval-owner-ui-fidelity-approval",
    "approval-release-manager-signoff",
    "approval-research-workspace-approval",
    "approval-runtime-science-promotion",
    "approval-source-use-commercial-clearance",
    "runtime-gmat-transfer-v1",
    "runtime-orekit-propagation-v1",
    "runtime-tudat-transfer-v1",
    "readiness-local-functional-beta"
  ],
  "blockerRows": [
    {
      "id": "readiness-deployment-readiness",
      "lane": "readiness",
      "owner": "Release engineering",
      "status": "blocked",
      "label": "Deployment readiness",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2,
      "blockerCount": 2,
      "blockers": [
        "Cloudflare Pages and the custom hostname are live from a git baseline, and a CI/CD workflow is committed, but the repo still needs a remote/secrets-backed run before it counts as reproducible promotion.",
        "Cloudflare Access anonymous challenge and monitor service-token verification pass; owner browser review remains a human approval step."
      ],
      "nextActions": [
        "Keep `npm run verify` green and deploy the Vite `dist` artifact only after visual approval.",
        "Use `npm run deploy:pages` for repeatable Pages deployment.",
        "Run CI/CD deployment from a named release branch or protected main baseline.",
        "Verify Cloudflare Access with an owner browser session and record the approval evidence."
      ],
      "requiredProof": "Raise Deployment readiness from 96 to 98 with evidence.",
      "rowHash": "sha256-c805769b67e8b23eb10fcf50a4dc6580dc6e5c8d7b751891af79c48ea3211c89"
    },
    {
      "id": "readiness-public-gated-live",
      "lane": "readiness",
      "owner": "Cloudflare/DNS",
      "status": "blocked",
      "label": "Public/gated website live status",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2,
      "blockerCount": 2,
      "blockers": [
        "The custom hostname is protected by Cloudflare Access; anonymous requests receive an Access challenge and the monitor service token reaches the app.",
        "A Worker Cron monitor and KV state store are live and healthy, but alert webhook/recovery proof still requires a real webhook or email relay."
      ],
      "nextActions": [
        "Record owner/reviewer browser approval after Cloudflare Access login.",
        "Verify alert and recovery delivery once a real webhook or email relay is attached."
      ],
      "requiredProof": "Raise Public/gated website live status from 96 to 98 with evidence.",
      "rowHash": "sha256-00e407daf21e704ec0b92fa33fbdd990d00062f0e3ecb0868c7f9c3eb78997a9"
    },
    {
      "id": "readiness-science-math-credibility",
      "lane": "readiness",
      "owner": "Science kernel",
      "status": "blocked",
      "label": "Science/math credibility for beta",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2,
      "blockerCount": 2,
      "blockers": [
        "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
        "Asteroid candidate CAD and SBDB source payloads are captured for the current worklist, but promotion remains blocked until MPC bridging, source-use review, human source-custody approval, and taxonomy/spectra/mission-archive composition evidence replace draft reviewer records."
      ],
      "nextActions": [
        "Keep established formulas covered by unit tests and source-integrity tests.",
        "Compare nominal solar irradiance against a cached Horizons Mercury snapshot with explicit tolerance.",
        "Label every planner score as heuristic and prevent heuristic claims from becoming verified physics.",
        "Preserve source query, units, uncertainty, license, and record hash metadata for every promoted model output.",
        "Regenerate deterministic model-artifact bundles before release and block promotion until runtime evidence passes.",
        "Keep seeded uncertainty ranges visible beside deterministic rankings so single-point scenario winners are not overstated.",
        "Keep capital, launch-mass, and horizon assumptions visible as planning heuristics until dated cost-source records are attached.",
        "Run live Horizons/SBDB/CAD refresh sampling and preserve generated source-query artifacts before claiming operational ephemerides."
      ],
      "requiredProof": "Raise Science/math credibility for beta from 96 to 98 with evidence.",
      "rowHash": "sha256-bf69ead8d648ea747cb4ea1537c92bc92e0a5041399b63e663f937ddbd080f5b"
    },
    {
      "id": "readiness-ui-review-readiness",
      "lane": "readiness",
      "owner": "Product design",
      "status": "blocked",
      "label": "UI review readiness",
      "currentScore": 90,
      "targetScore": 98,
      "gap": 8,
      "blockerCount": 2,
      "blockers": [
        "The product shell and six primary pages have been rebuilt closer to the accepted mockup direction, but side-by-side screenshot fidelity still needs final page-by-page approval.",
        "Mobile no-overflow rendering and collapsible navigation are covered, but final typography/spacing approval against the reference set is still pending."
      ],
      "nextActions": [
        "Finish propagating the code-native SVG logo/wordmark into export payloads and final review artifacts.",
        "Rebuild Command Overview, Scenario Compare, Solar Clock, Body Ledger, Process Lab, and Claims Register from the mockups.",
        "Run a mismatch ledger against the accepted mockups before approval."
      ],
      "requiredProof": "Raise UI review readiness from 90 to 98 with evidence.",
      "rowHash": "sha256-62d72402cd5bb7e84ba76ba9971f98bd25f7fe48ff3438f6314c0695f1a5e103"
    },
    {
      "id": "release-economics-promotion",
      "lane": "release-gate",
      "owner": "Business modeling",
      "status": "blocked",
      "label": "Economics promotion",
      "requiredProof": "Dated, normalized cost and economics source payloads are model-ready.",
      "blocker": "Economics records are still blocked from commercial economics claims.",
      "nextActions": [
        "Promote dated launch, delivery, capex, opex, market, and award records through source intake."
      ],
      "evidenceHash": "sha256-f1eafc986846fd7177bc48108c23465badb3a0649f22a041eccdb4ea49c7bdec",
      "rowHash": "sha256-20dbf5226cd1b697a18191018b0f9dfb33b47c0ac52403fa75b97d6faeb863c7"
    },
    {
      "id": "release-materials-process-promotion",
      "lane": "release-gate",
      "owner": "Manufacturing science",
      "status": "blocked",
      "label": "Materials/process promotion",
      "requiredProof": "Process-specific material property payloads and Cantera/MOOSE/OpenFOAM or equivalent runtime artifacts are promoted.",
      "blocker": "Materials/process records are still blocked from process, throughput, quality, and cost claims.",
      "nextActions": [
        "Promote reviewed NIST/Materials Project/PDS material records and runtime process artifacts before using process claims commercially."
      ],
      "evidenceHash": "sha256-67744ee0ca9038f1fcf83232c50eaa5466b8da24b4e43744bb75fcc0dc0d8609",
      "rowHash": "sha256-e4f1ba7f9f803455749267bab9b183910cffecf74b4d0690cf14d459bdf91b1c"
    },
    {
      "id": "release-research-package-approval",
      "lane": "release-gate",
      "owner": "Product/review",
      "status": "blocked",
      "label": "Research package approval",
      "requiredProof": "At least one package has no blocked workspace/package/review gates and its customer readiness contract allows commercial use.",
      "blocker": "All customer-facing research packages remain beta-blocked and commercial-use contracts are not clear.",
      "nextActions": [
        "Clear customer readiness contract blockers or keep packages explicitly beta-blocked."
      ],
      "evidenceHash": "sha256-8dc2fbcac5fbb32800d773cd3f37c65e7b746a6cef2396b3ed803fbd653270fa",
      "rowHash": "sha256-219e41abb6915681f622918d95462a08e3a620410da76b3a6d7e8c08e9912e1b"
    },
    {
      "id": "release-resource-candidate-promotion",
      "lane": "release-gate",
      "owner": "Resource ledger",
      "status": "blocked",
      "label": "Resource candidate promotion",
      "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance exist for promoted resource claims.",
      "blocker": "Asteroid candidates have geometry-screen evidence only; candidate source custody, resource composition, and customer-use gates remain blocked.",
      "nextActions": [
        "Promote candidate-specific source work-order intake reports, then attach taxonomy/spectra/mission evidence and source-use clearance before resource promotion."
      ],
      "evidenceHash": "sha256-c5f5de33dcd3d07c91c1455771309a8a507a4c2331f15f51a34d1257c42fa014",
      "rowHash": "sha256-b91d733b72ee16c4e8fe27f0e7d46522ad5bc20957c2e4f952e355f6dedfb365"
    },
    {
      "id": "release-source-use-rights-review",
      "lane": "release-gate",
      "owner": "Source/legal review",
      "status": "blocked",
      "label": "Source use-rights review",
      "requiredProof": "Every source used in customer-facing reports has captured terms/license evidence, citation policy, redistribution decision, and reviewer approval.",
      "blocker": "Source-use rights remain blocked for customer/commercial use and raw payload redistribution.",
      "nextActions": [
        "Capture source-specific terms/license artifacts and reviewer approvals before customer/commercial use."
      ],
      "evidenceHash": "sha256-7c83e8fa02c13925fc2e98d96f886753165eca42ded5e81f6512403559d42c26",
      "rowHash": "sha256-7976be68aca2a4f5b6c763d3219ce24bfceee66e2a9b869fc244e6e20fbe1c43"
    },
    {
      "id": "release-workspace-review-gates",
      "lane": "release-gate",
      "owner": "Research operations",
      "status": "blocked",
      "label": "Workspace review gates",
      "requiredProof": "Workspace source, claims, sidecar, and package gates are not blocked.",
      "blocker": "All research workspaces still have at least one blocked review gate.",
      "nextActions": [
        "Resolve blocked workspace gates before customer delivery."
      ],
      "evidenceHash": "sha256-81d6b5f5634da3028d37bda9bfa4a8418b11537e8f7fde90823a621c443ad27f",
      "rowHash": "sha256-1501df0586e374e52a965bfbef2f9eeca942be1e336fa3c4fa47604779ff45c0"
    },
    {
      "id": "release-alert-webhook-recovery-proof",
      "lane": "release-gate",
      "owner": "Cloudflare/DNS",
      "status": "external-proof-pending",
      "label": "Alert webhook and recovery proof",
      "requiredProof": "Two forced monitor failures emit one alert, then restored target emits one recovery alert.",
      "blocker": "Alert webhook/recovery path is not verified.",
      "nextActions": [
        "Attach a real webhook/email relay and run the forced failure/recovery proof."
      ],
      "evidenceHash": "sha256-01899c59e6ec3ea6f2ba918c6c6c4d474568778ea9af287534ee64e5b8c6ec87",
      "rowHash": "sha256-b4a990664a02b3d5594c1a0cc9315a1453842c3a778d12674d2337d9ac658cf8"
    },
    {
      "id": "release-ci-secrets-deploy-proof",
      "lane": "release-gate",
      "owner": "Release engineering",
      "status": "external-proof-pending",
      "label": "CI secrets deploy proof",
      "requiredProof": "A remote CI run from a release branch/main with Cloudflare secrets deploys the exact artifact.",
      "blocker": "No remote/secrets-backed CI deploy receipt is attached.",
      "nextActions": [
        "Run GitHub Actions deployment with configured Cloudflare secrets."
      ],
      "evidenceHash": "sha256-20eb7b2355a9c248664bc765af1a8b4b420ebea54ee331670657fa48ee96e177",
      "rowHash": "sha256-3b53d5690cdbf1d9838a774b487027fbfeee0ce4066711ca9f08fb5626a43e88"
    },
    {
      "id": "release-cloudflare-access-owner-approval",
      "lane": "release-gate",
      "owner": "Release engineering",
      "status": "human-review-pending",
      "label": "Cloudflare Access owner approval",
      "requiredProof": "Owner/reviewer browser session reaches the gated app and anonymous browser receives Access challenge.",
      "blocker": "Owner browser approval evidence is not recorded in this repo.",
      "nextActions": [
        "Record owner/reviewer browser approval evidence after Access login."
      ],
      "evidenceHash": "sha256-51282edd965870e3ae31b422b1da1587abf343b4ab2f38fb170c4f28730250ca",
      "rowHash": "sha256-963a480cb016106ee7c1d8b58f78f0a3c86627d206e5e0667b082a5fc66d62a4"
    },
    {
      "id": "release-ui-fidelity-owner-approval",
      "lane": "release-gate",
      "owner": "Product design / owner",
      "status": "human-review-pending",
      "label": "UI fidelity owner approval",
      "requiredProof": "Owner-approved side-by-side screenshots against the six accepted mockups.",
      "blocker": "Exact mockup fidelity approval is not recorded.",
      "nextActions": [
        "Run screenshot mismatch ledger and record owner approval."
      ],
      "evidenceHash": "sha256-b422135113500bb848a26000351aa0551516cc28ba293b43092bc4ff56a8cf33",
      "rowHash": "sha256-765a384d5d428f189a3f81e6094442965aeb91ffdcd81e4d530204b224119934"
    },
    {
      "id": "release-model-validation-protocols",
      "lane": "release-gate",
      "owner": "Science/product governance",
      "status": "partial",
      "label": "Model validation protocols",
      "requiredProof": "Every model domain has acceptance criteria, required source/runtime gates, test vectors, and commercial-use state.",
      "blocker": "Ephemeris geometry and contact/event-window validation: Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1 Small-body orbit, close-approach, and resource-candidate validation: Runtime sidecar artifact not promoted: orekit-propagation-v1 Trajectory, transfer, and logistics cross-tool validation: Runtime sidecar artifact not promoted: orekit-propagation-v1",
      "nextActions": [
        "Resolve model-validation protocol blockers by promoting required source payloads and runtime sidecar artifacts."
      ],
      "evidenceHash": "sha256-ea0c0f9e7a5a5a2fd80c4884183ab73503bf3a387b284af323e7ea2d059bdb58",
      "rowHash": "sha256-fae80a8799ec206fb7220355a935636d03e76cb3beeb1a0fc2e3ba43ab48e5a0"
    },
    {
      "id": "release-runtime-sidecar-promotion",
      "lane": "release-gate",
      "owner": "Science compute",
      "status": "partial",
      "label": "Runtime sidecar promotion",
      "requiredProof": "At least one runtime sidecar artifact promotes through the sidecar intake validation gate.",
      "blocker": "3 sidecar contract(s) still lack promoted runtime artifacts.",
      "nextActions": [
        "Start with SPICE GF event windows or Orekit propagation, then cross-check with GMAT/Tudat."
      ],
      "evidenceHash": "sha256-6aa27a906a7eee620ec927e44047d1950315ae88ab586a97c09ba1f8b9105088",
      "rowHash": "sha256-510e09a43e810ccfb046eff7313296f66d66529253e3ce97d21a5da7bb172149"
    },
    {
      "id": "approval-customer-report-delivery-approval",
      "lane": "human-approval",
      "owner": "Research product lead",
      "status": "blocked-customer-delivery",
      "label": "Customer report delivery approval",
      "requiredProof": "Every customer report packet has source-use, runtime, economics, resource, workspace, wording, and reviewer approval before delivery.",
      "nextActions": [
        "Use report packets for internal review and paid-beta scoping only until proof gates pass."
      ],
      "evidenceHash": "sha256-5aa6adfcb8f8780607f43c7fbb14e774f3a3f78ec33ce9ebdc9ec2e43c9c4312",
      "rowHash": "sha256-e7e6698f5d2bc8e5f626b7db0ce0ecbd12fc6f5f6994175539034ab3669ca0e7"
    },
    {
      "id": "approval-monitor-alert-recovery-proof",
      "lane": "human-approval",
      "owner": "Release engineering",
      "status": "external-proof-required",
      "label": "Monitor alert and recovery proof",
      "requiredProof": "Real webhook or email relay receives exactly one failure alert after two forced failures and one recovery alert after target restoration.",
      "nextActions": [
        "Attach a real alert endpoint, force two failures, restore target, and archive alert/recovery receipts."
      ],
      "evidenceHash": "sha256-44165e57f9b308a5aab7452bf34d2f82f9abee856d93ab6962304975ef9e8814",
      "rowHash": "sha256-8c662944f205df748dc571d734f9b4480fe90753fa8e312265b6f2e6b6f25cca"
    },
    {
      "id": "approval-owner-ui-fidelity-approval",
      "lane": "human-approval",
      "owner": "Product owner",
      "status": "human-approval-required",
      "label": "Owner UI fidelity approval",
      "requiredProof": "Owner confirms the six accepted mockup pages match the intended review standard on desktop and mobile with no material omissions.",
      "nextActions": [
        "Capture owner screenshot approval against the accepted six-page reference set."
      ],
      "evidenceHash": "sha256-e81f71f8d5b7e2f70e0f1b84e79a4489e577bd7b055e90a56ed1342405bed2f0",
      "rowHash": "sha256-988a83c7addf5a370fe8955878ea34fa2abf7a67a057ce21dafd43f05c1c2d7c"
    },
    {
      "id": "approval-release-manager-signoff",
      "lane": "human-approval",
      "owner": "Release manager",
      "status": "blocked-until-all-required-slots-pass",
      "label": "Release manager signoff",
      "requiredProof": "All required signoff slots are approved with hashes, receipts, and release notes before claiming public/customer beta readiness.",
      "nextActions": [
        "Approve only after owner UI, source-use, runtime science, customer delivery, workspace, and alert proof slots pass."
      ],
      "evidenceHash": "sha256-3e0e53c8891e5c8ed3e7dd824732d661cf37c75747d7bcc63c5c5d14ce8bf3b0",
      "rowHash": "sha256-57064266c7e2a5113bf31140450200f4cddf5782bfb944a08bb97ffb74bf4d61"
    },
    {
      "id": "approval-research-workspace-approval",
      "lane": "human-approval",
      "owner": "Research operations",
      "status": "blocked-workspace-review",
      "label": "Research workspace approval",
      "requiredProof": "Each research workspace has reviewed scope, run refs, package refs, source refs, and closure actions before it is sold as a customer workstream.",
      "nextActions": [
        "Assign reviewer and close workspace review gates per package lane."
      ],
      "evidenceHash": "sha256-43f45e81535773334e99e98ac7bccbea1e6044b0f943389c72c02425d0384479",
      "rowHash": "sha256-43444fc21ab5b723abb2ffb785e4bb041d93448fa7b658005b6a2008803b06c1"
    },
    {
      "id": "approval-runtime-science-promotion",
      "lane": "human-approval",
      "owner": "Science compute lead",
      "status": "blocked-runtime-promotion",
      "label": "Runtime science promotion",
      "requiredProof": "SPICE/Orekit/GMAT/Tudat/OpenMDAO outputs pass runtime artifact validation and independent review before mission-design claims promote.",
      "nextActions": [
        "Promote Orekit, GMAT, and Tudat runtime artifacts through the sidecar intake gate."
      ],
      "evidenceHash": "sha256-5ead30324385202210a372715d20c7746286d5cb4293ee8cc7e7a255b1b5ad2a",
      "rowHash": "sha256-57e9004ff52d257531bc44d069443cb88cd2146c9ff59bcae55dee98b3a39801"
    },
    {
      "id": "approval-source-use-commercial-clearance",
      "lane": "human-approval",
      "owner": "Legal/source review",
      "status": "blocked-source-use-review",
      "label": "Source-use commercial clearance",
      "requiredProof": "Each source has customer/commercial use policy reviewed before report redistribution or derived-value claims are sold.",
      "nextActions": [
        "Review and approve source-use packets source by source before customer report delivery."
      ],
      "evidenceHash": "sha256-7d8b4b14f0d11889079d0f04e31c425c8e6e960e91b190280055c105075cbab7",
      "rowHash": "sha256-ca417f874357a0428b1518b84b4001540c498788ae561457ae882d3796706978"
    },
    {
      "id": "runtime-gmat-transfer-v1",
      "lane": "runtime-science",
      "owner": "Science compute",
      "status": "blocked-before-runtime-generation",
      "label": "NASA GMAT gmat-transfer-v1",
      "requiredProof": "Preflight is current and ready-to-run in the execution shell. Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived. Runtime artifact includes required field: gmatVersion. Runtime artifact includes required field: runAt. Runtime artifact includes required field: scenarioId. Runtime artifact includes required field: scriptHash. Runtime artifact includes required field: epoch. Runtime artifact includes required field: forceModel. Runtime artifact includes required field: optimizer. Runtime artifact includes required field: trajectorySummary. Runtime artifact includes required field: constraintSummary. Runtime artifact includes required field: units. Runtime artifact includes required field: uncertainty. Runtime artifact includes required field: reproducibleCommand. Runtime artifact includes required field: inputsHash. Runtime artifact includes required field: outputsHash. Runtime artifact includes required field: checksums. Runtime artifact includes required field: independentComparison. Runtime artifact includes required field: limitations. Runtime artifact includes required field: validationStatus. Artifact validationStatus is passed. Artifact sourceIds match the contract source IDs. Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums. Artifact passes npm run science:sidecar:intake and writes an intake report. A reviewer approves claim-level use before scenario decisions or customer packages change. Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.. Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.. Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers.. Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.. Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact..",
      "blocker": "Missing command/runtime: GMAT Runtime artifact is not promoted.",
      "nextActions": [
        "Resolve runtime prerequisites: Missing command/runtime: GMAT."
      ],
      "command": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "validationCommand": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/gmat-transfer-v1-runtime-intake-report.json artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "evidenceHash": "sha256-479bf8e7620ba57bf5b6d7f1e9e8bc45f8c5ab0febc5db44aa5364edf16e543c",
      "rowHash": "sha256-47969fb11a9f6bdb76cc3bf6c8021d9ab51ebab60e070aa7c7704f92b8cdea11"
    },
    {
      "id": "runtime-orekit-propagation-v1",
      "lane": "runtime-science",
      "owner": "Science compute",
      "status": "blocked-before-runtime-generation",
      "label": "Orekit orekit-propagation-v1",
      "requiredProof": "Preflight is current and ready-to-run in the execution shell. Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived. Runtime artifact includes required field: toolVersion. Runtime artifact includes required field: runAt. Runtime artifact includes required field: scenarioId. Runtime artifact includes required field: dataContext. Runtime artifact includes required field: frames. Runtime artifact includes required field: timeScale. Runtime artifact includes required field: forceModel. Runtime artifact includes required field: events. Runtime artifact includes required field: units. Runtime artifact includes required field: uncertainty. Runtime artifact includes required field: reproducibleCommand. Runtime artifact includes required field: inputsHash. Runtime artifact includes required field: outputsHash. Runtime artifact includes required field: checksums. Runtime artifact includes required field: independentComparison. Runtime artifact includes required field: limitations. Runtime artifact includes required field: validationStatus. Artifact validationStatus is passed. Artifact sourceIds match the contract source IDs. Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums. Artifact passes npm run science:sidecar:intake and writes an intake report. A reviewer approves claim-level use before scenario decisions or customer packages change. Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.. Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.. Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers.. Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.. Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact..",
      "blocker": "Missing command/runtime: Java Missing path or env input: OREKIT_DATA_PATH Missing path or env input: OREKIT_SIDECAR_JAR Runtime artifact is not promoted.",
      "nextActions": [
        "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR."
      ],
      "command": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
      "validationCommand": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/orekit-propagation-v1-runtime-intake-report.json artifacts/sidecars/orekit-propagation-v1.json",
      "evidenceHash": "sha256-0680305ee69e8c919ba9921eabcf929dc7d73c1a314883c5e9018fb139531824",
      "rowHash": "sha256-66aacddec7a944dcd139418da07ef6b3efaf3f775134d6a9bcc85f2a3364b0de"
    },
    {
      "id": "runtime-tudat-transfer-v1",
      "lane": "runtime-science",
      "owner": "Science compute",
      "status": "blocked-before-runtime-generation",
      "label": "Tudat tudat-transfer-v1",
      "requiredProof": "Preflight is current and ready-to-run in the execution shell. Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived. Runtime artifact includes required field: toolVersion. Runtime artifact includes required field: runAt. Runtime artifact includes required field: scenarioId. Runtime artifact includes required field: bodySettings. Runtime artifact includes required field: integrator. Runtime artifact includes required field: propagatorSettings. Runtime artifact includes required field: trajectorySummary. Runtime artifact includes required field: residualSummary. Runtime artifact includes required field: units. Runtime artifact includes required field: uncertainty. Runtime artifact includes required field: reproducibleCommand. Runtime artifact includes required field: inputsHash. Runtime artifact includes required field: outputsHash. Runtime artifact includes required field: checksums. Runtime artifact includes required field: independentComparison. Runtime artifact includes required field: limitations. Runtime artifact includes required field: validationStatus. Artifact validationStatus is passed. Artifact sourceIds match the contract source IDs. Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums. Artifact passes npm run science:sidecar:intake and writes an intake report. A reviewer approves claim-level use before scenario decisions or customer packages change. Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.. Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.. Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers.. Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.. Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact..",
      "blocker": "Missing Python module: tudatpy Runtime artifact is not promoted.",
      "nextActions": [
        "Resolve runtime prerequisites: Missing Python module: tudatpy."
      ],
      "command": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "validationCommand": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/tudat-transfer-v1-runtime-intake-report.json artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "evidenceHash": "sha256-e40b92b6c47017730c5c96f4aabf5a5194389cc23c0dbbc959508ed6495cd228",
      "rowHash": "sha256-f984cdb6ecd1ac7fbddc886bb69168104c5b65c03cb5cbc023a76feeb8e15351"
    },
    {
      "id": "readiness-local-functional-beta",
      "lane": "readiness",
      "owner": "Product engineering",
      "status": "pass",
      "label": "Local functional beta",
      "currentScore": 98,
      "targetScore": 98,
      "gap": 0,
      "blockerCount": 2,
      "blockers": [
        "Desktop and mobile browser regression now covers all eleven primary pages plus formula recomputation, snapshot/report/claims/package JSON exports, and approval-log mutation.",
        "Shared UI primitives, the app shell/navigation/status strip, all primary page modules, Scenario Compare evidence inspector panels, Source Library evidence panels, Research Packages evidence panels, Solar Clock orbit/timeline chart primitives, Process Lab flow/body-fit chart primitives, shared evidence panels across Research Packages, Approval Board, Scenario Compare, Source Library, Asteroid Scanner, Body Ledger, Process Lab, Formula Lab, Solar Clock, and Platform Roadmap detail sections, shared table controls, shared evidence stack lists across Source Library and Research Packages queues, proof-gap sections, blocker summaries, and customer package cards, shared score-bar chart primitives across Command Overview, Scenario Compare, Asteroid Scanner, and Source Library, app-level JSON export payloads, app-level export controls, hash-backed review entries, shared review action controls, and the Claims Register JSON export control are split out; local functional beta target is met pending the separate UI approval, science-runtime, CI promotion, Access owner-review, and alert-recovery gates."
      ],
      "nextActions": [
        "Keep Solar Clock and Process Lab visual chart primitives covered by modularization tests.",
        "Keep browser checks for snapshot/report/claims export actions and approval-log mutation green.",
        "Keep committed desktop and mobile rendered-browser smoke tests green for every primary page."
      ],
      "requiredProof": "Readiness category is at or above target.",
      "rowHash": "sha256-1ee55e7c16636dd433f9c9a737c7ab4e78b5768291023c58ded1437b8e248278"
    }
  ],
  "closureCommands": [
    "Approve only after owner UI, source-use, runtime science, customer delivery, workspace, and alert proof slots pass.",
    "Assign reviewer and close workspace review gates per package lane.",
    "Attach a real alert endpoint, force two failures, restore target, and archive alert/recovery receipts.",
    "Attach a real webhook/email relay and run the forced failure/recovery proof.",
    "Capture owner screenshot approval against the accepted six-page reference set.",
    "Capture source-specific terms/license artifacts and reviewer approvals before customer/commercial use.",
    "Clear customer readiness contract blockers or keep packages explicitly beta-blocked.",
    "Compare nominal solar irradiance against a cached Horizons Mercury snapshot with explicit tolerance.",
    "Finish propagating the code-native SVG logo/wordmark into export payloads and final review artifacts.",
    "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
    "Keep `npm run verify` green and deploy the Vite `dist` artifact only after visual approval.",
    "Keep browser checks for snapshot/report/claims export actions and approval-log mutation green.",
    "Keep capital, launch-mass, and horizon assumptions visible as planning heuristics until dated cost-source records are attached.",
    "Keep committed desktop and mobile rendered-browser smoke tests green for every primary page.",
    "Keep established formulas covered by unit tests and source-integrity tests.",
    "Keep seeded uncertainty ranges visible beside deterministic rankings so single-point scenario winners are not overstated.",
    "Keep Solar Clock and Process Lab visual chart primitives covered by modularization tests.",
    "Label every planner score as heuristic and prevent heuristic claims from becoming verified physics.",
    "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/gmat-transfer-v1-runtime-intake-report.json artifacts/sidecars/gmat/gmat-transfer-v1.json",
    "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/orekit-propagation-v1-runtime-intake-report.json artifacts/sidecars/orekit-propagation-v1.json",
    "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/tudat-transfer-v1-runtime-intake-report.json artifacts/sidecars/tudat/tudat-transfer-v1.json",
    "Preserve source query, units, uncertainty, license, and record hash metadata for every promoted model output.",
    "Promote candidate-specific source work-order intake reports, then attach taxonomy/spectra/mission evidence and source-use clearance before resource promotion.",
    "Promote dated launch, delivery, capex, opex, market, and award records through source intake.",
    "Promote Orekit, GMAT, and Tudat runtime artifacts through the sidecar intake gate.",
    "Promote reviewed NIST/Materials Project/PDS material records and runtime process artifacts before using process claims commercially.",
    "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
    "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
    "Rebuild Command Overview, Scenario Compare, Solar Clock, Body Ledger, Process Lab, and Claims Register from the mockups.",
    "Record owner/reviewer browser approval after Cloudflare Access login.",
    "Record owner/reviewer browser approval evidence after Access login.",
    "Regenerate deterministic model-artifact bundles before release and block promotion until runtime evidence passes.",
    "Resolve blocked workspace gates before customer delivery.",
    "Resolve model-validation protocol blockers by promoting required source payloads and runtime sidecar artifacts.",
    "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
    "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
    "Resolve runtime prerequisites: Missing Python module: tudatpy.",
    "Review and approve source-use packets source by source before customer report delivery.",
    "Run a mismatch ledger against the accepted mockups before approval.",
    "Run CI/CD deployment from a named release branch or protected main baseline.",
    "Run GitHub Actions deployment with configured Cloudflare secrets.",
    "Run live Horizons/SBDB/CAD refresh sampling and preserve generated source-query artifacts before claiming operational ephemerides.",
    "Run screenshot mismatch ledger and record owner approval.",
    "Start with SPICE GF event windows or Orekit propagation, then cross-check with GMAT/Tudat.",
    "Use `npm run deploy:pages` for repeatable Pages deployment.",
    "Use report packets for internal review and paid-beta scoping only until proof gates pass.",
    "Verify alert and recovery delivery once a real webhook or email relay is attached.",
    "Verify Cloudflare Access with an owner browser session and record the approval evidence."
  ],
  "evidenceHashes": {
    "releaseEvidenceLedger": "sha256-c199aaa636095440da451e434bb3e2605abba466020771855b8292316c3df895",
    "betaReviewDocket": "sha256-e0c986eb0390db2490b64e5908012bf58f21fd8008f1c54fe84db3775d7123dc",
    "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
    "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
    "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
    "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
    "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18"
  },
  "markdownPath": "public/beta-closure-status.md",
  "markdownHash": "sha256-931f8509ae2fa08b16145328cc6fe787aed813f4e34bc644100f5d63561db84a",
  "statusHash": "sha256-c309bd89c88a3393b159ebb51b0c125365b6fcd3a27a18aa082babc0c0512635"
}
;
